import React, { useEffect, useState } from "react";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import MultiSelectAndSearch from "./MultiSelectAndSearch";
import { notification } from "antd";
import apiService from "../../../service/apiservice/apiService";

const OfficeMultiSelect = ({
  data,
  setData,
  isMultiSelect,
  error,
  required,
}) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [masterOfficeList, setOfficeList] = useState([]);

  const handleOfficesChange = (value) => {
    const filteredOffices = masterOfficeList.filter((office) =>
      value.includes(office.name),
    );

    setData((prev) => ({ ...prev, offices: filteredOffices }));
  };

  useEffect(() => {
    const getOfficeList = async () => {
      try {
        const endpoint = "niramayafoundation/niramayaoffice/api/v1/offices";
        const params = {
          organizationIdentifier,
        };
        const officeResponse = await apiService.get(endpoint, params);

        if (!officeResponse) {
          throw new Error(`Office response not found`);
        }
        setOfficeList(officeResponse);
      } catch (error) {
        notification.error({
          message: error?.message || "Something went wrong",
          placement: "bottomRight",
        });
      }
    };

    getOfficeList();
  }, [organizationIdentifier]);

  return (
    <>
      <MultiSelectAndSearch
        optionsData={{
          label: "Offices",
          value: "offices",
          menuItems: masterOfficeList?.map((item) => item.name) || [],
        }}
        data={data?.offices?.map((item) => item?.name) || []}
        setData={handleOfficesChange}
        isMultiSelect={isMultiSelect}
        error={error?.offices}
        required={required}
      />
    </>
  );
};

export default OfficeMultiSelect;
